export const MAX_REQUEST_AMOUNT = {
    UK: 1000000,
    DE: 500000
};
